<template>
  <v-app>
    <NavDrawer
      :visible="navDrawerVisible"
      @closed="onNavDrawerClosed"
    >
    </NavDrawer>
    <AppBar
      @toggleNavDrawer="toggleNavDrawer"
      @search="searchBySerialNumber"
      :searching="searching"
      v-if="showAppBar"
    >
    </AppBar>

    <AlignerDetailDialog
      :dialog="showAlignerDetailDialog"
      :aligner="aligner"
      @close="closeAlignerDetailDialog()"
      @refresh="refreshAlignerDetailDialog()"
    >
    </AlignerDetailDialog>

    <v-content v-if="notBusy">
      <v-container fluid class="background">
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
    >
      {{ snackbarText }}
      <v-btn
        color="pink"
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="alertVisible"
      timeout="10000"
    >
      {{ alertText }}
      <v-btn
        color="pink"
        text
        @click="alertVisible = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

    <v-overlay :value="showBusyOverylay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-app>
</template>

<script>
import AppBar from './components/AppBar.vue';
import NavDrawer from './components/NavDrawer.vue';
import AlignerDetailDialog from './components/aligners/AlignerDetailDialog.vue';

export default {
  name: 'App',

  components: {
    NavDrawer,
    AppBar,
    AlignerDetailDialog,
  },

  data() {
    return {
      navDrawerVisible: false,
      searching: false,
      snackbar: false,
      snackbarText: '',
      showAlignerDetailDialog: false,
      aligner: {},
    };
  },

  computed: {
    alertVisible: {
      get() {
        return this.$store.state.alert.visible;
      },

      set(value) {
        this.$store.commit('setAlertVisible', value);
      },
    },

    alertText: {
      get() {
        return this.$store.state.alert.text;
      },
    },

    showBusyOverylay() {
      return this.$store.state.busy;
    },

    showAppBar() {
      return !!this.$store.state.auth.token;
    },

    notBusy() {
      return !this.$store.state.busy;
    },
  },

  methods: {
    toggleNavDrawer() {
      this.navDrawerVisible = !this.navDrawerVisible;
    },

    searchBySerialNumber(serialNumber) {
      const options = {
        method: 'get',
        url: `/read/aligner/v1/?serialNumber=${serialNumber.toUpperCase()}&username=${this.$store.state.auth.token.user.username}`,
      };

      this.searching = true;

      this.axios(options)
        .then((res) => {
          this.searching = false;

          this.aligner = res.data;
          this.showAlignerDetailDialog = true;
        })
        .catch((err) => {
          this.searching = false;

          this.snackbarText = `Serial number ${serialNumber.toUpperCase()} not found.`;
          this.snackbar = true;
        });
    },

    onNavDrawerClosed() {
      this.navDrawerVisible = false;
    },

    refreshAlignerDetailDialog() {
      const options = {
        method: 'get',
        url: `/read/aligner/v1/?serialNumber=${this.aligner.serialNumber.toUpperCase()}&username=${this.$store.state.auth.token.user.username}`,
      };

      this.axios(options)
        .then((res) => {
          this.aligner = res.data;
        });
    },

    closeAlignerDetailDialog() {
      this.showAlignerDetailDialog = false;
    },
  },
};
</script>

<style scoped>
.background {
  background: url('./assets/images/background_muted-no_bug.png');
  background-size: cover !important;
  width: 100%;
  height: 100%;
}
</style>
